import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const listSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.list, {
        variants: {
            variant: {
                marker: {
                    root: {
                        listStyle: 'disc',
                    },
                    item: {
                        _marker: {
                            color: 'inherit',
                        },
                    },
                },
            },
        },
    }),
);
